import {
  CellReviewShell,
  FieldCommentCorner,
} from "@platform/btx-plan-designer";

import { useCellReviewCellStyle } from "../shared/cellReviews/useCellReviewCellStyle";

import { deriveResponsesCellForRenderer } from "./responsesCellReviewIdentity";

import type { ICellRendererParams } from "ag-grid-community";
import type { ResponsesGridRow } from "./types";

/**
 * AG Grid cell renderer for Responses coverage columns. Applies the
 * "Needs Review" (yellow) and "Highlight" (blue) background tints and a
 * comment corner indicator, then renders the pre-formatted cell value.
 */
export const ResponsesCellRenderer = (
  params: ICellRendererParams<ResponsesGridRow>,
): React.JSX.Element => {
  const { backgroundColor, comment } = useCellReviewCellStyle(
    deriveResponsesCellForRenderer(params),
  );

  return (
    <CellReviewShell
      backgroundColor={backgroundColor}
      overlays={comment && <FieldCommentCorner comment={comment} />}
    >
      {params.valueFormatted ?? String(params.value ?? "")}
    </CellReviewShell>
  );
};
